import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Neighborhood Theme Components
import NeighborhoodNavbar from './components/NeighborhoodNavbar';
import NeighborhoodHero from './components/NeighborhoodHero';
import NeighborhoodMenu from './components/NeighborhoodMenu';
import WeeklySpecialsSection from './components/WeeklySpecialsSection';
import FoodGallerySection from './components/FoodGallerySection';
import LiveMusicSection from './components/LiveMusicSection';
import NeighborhoodAbout from './components/NeighborhoodAbout';
import NeighborhoodHours from './components/NeighborhoodHours';
import NeighborhoodFooter from './components/NeighborhoodFooter';
import HappyHourBanner from './components/HappyHourBanner';
import CornerBanner from './components/CornerBanner';
import TriviaBanner from './components/TriviaBanner';

// Client Mockup (lazy-loaded so the main site bundle stays lean)
const ClientMockup = React.lazy(() => import('./components/ClientMockup'));

const MainSite = () => (
  <div className="bg-[#FFFBF5] min-h-screen">
    <a href="#menu" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[200] focus:bg-[#C9A227] focus:text-[#1a1612] focus:px-4 focus:py-2">Skip to content</a>
    <TriviaBanner />
    <NeighborhoodNavbar />
    <CornerBanner />
    <main>
      <NeighborhoodHero />
      <NeighborhoodAbout />
      <NeighborhoodMenu />
      <WeeklySpecialsSection />
      <FoodGallerySection />
      <LiveMusicSection />
      <NeighborhoodHours />
    </main>
    <NeighborhoodFooter />
    <HappyHourBanner />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <React.Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<MainSite />} />
            <Route path="/mockup" element={<ClientMockup />} />
            {/* Unknown paths fall back to the main site */}
            <Route path="*" element={<MainSite />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
